// declare var $

export function buildTile(data, classes = '') {
  const htmlArray:string[] = []
  
  htmlArray.push('<div class="tile '+classes+'" data-id="'+data.id+'">')
  htmlArray.push('<div class="tile__content pl-corridor pt-4xl pr-4xl">')
  if (data.categories && data.categories.length > 0) htmlArray.push('<h4 class="tile__categories">'+ data.categories.join(', ') +'</h4>') 
  htmlArray.push('<div class="tile__title"><h3 class="h3">'+ data.title +'</h3></div>')
  if (data.excerpt !== '') htmlArray.push('<p class="tile__excerpt pb-2xl">'+ data.excerpt +'</p>')
  htmlArray.push('<a class="romeo-button romeo-button-primary" href="'+data.permalink+'"><span>Learn More</span></a>')
  htmlArray.push('</div>')
  htmlArray.push( buildTileImage( data.image, data.title ) )
  htmlArray.push('</div>')

  return htmlArray.join('')
}

export function buildTiles( dataSet, classes = '' ) {
  const tiles:string[] = []
  for (let i = 0, ilen = dataSet.length; i < ilen; i++) {
    tiles.push( buildTile(dataSet[i], classes) )
  }
  return tiles.join('')
}


export function buildTilePlaceholders(count:number, classes = '' ) {
  const htmlArray:string[] = []
  for (let i = 0, ilen = count; i < ilen; i++) {
    htmlArray.push('<div class="tile placeholder '+classes+'"><div class="tile__content pl-corridor pt-4xl pr-4xl"></div><div class="tile__image rtl-md rbl-xs"></div></div>')
  }
  return htmlArray.join('')
}

// Helpers

function buildTileImage( image, title ) {
  if (image && image !== '') {
    return '<div class="tile__image"><img src="'+image+'" class="rtl-md rbl-xs" alt="'+title+'" /></div>'
  } else {
    return '<div class="tile__image no-image"></div>'
  }
}
